var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sysadmin || _vm.adminrights)?_c('common-page-layout',[_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('/admin/customerremedials/processing')}}},[_vm._v("Current Remedials")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de1e71d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/customerremedials/AdminCustomersRemedialsHome.vue
// module id = 434
// module chunks = 1